import React, { Component } from "react";
import GridLayout from "react-grid-layout";
import CircularProgress from "../Circular/Circular";
import Visibility from "@material-ui/icons/Visibility";
import Edit from "@material-ui/icons/Edit";
import LockOpen from "@material-ui/icons/LockOpen";
import Control from "../../assets/img/control.png";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import IconButton from "@material-ui/core/IconButton";
import Available from "../../assets/img/available_w.png";
import Allocated from "../../assets/img/allocated_w.png";
import Reserved from "../../assets/img/reserved_w.png";
import ToBeFree from "../../assets/img/to_be_free_w.png";
import Block from "../../assets/img/block_w.png";
import Warning from "../../assets/img/warning.png";
import { withStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Icon from "@material-ui/core/Icon";
import {
  getSlots as buscarEscaninho,
  openSlot,
} from "../../services/slots/slots";
import { getLockerById } from "../../services/lockers/lockers";
import EditSlot from "components/Slots/EditSlot";
import ViewSlot from "components/Slots/ViewSlot";
import OpenSlot from "components/Slots/OpenSlot";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import VerticalSplit from '@material-ui/icons/VerticalSplit';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
import { parseLocker, parseLockerKey } from "./parseLocker";


import "./style.css";
import { Lock } from "@material-ui/icons";

const useStyles = () => ({
  ...styles,
  root: {
    flexGrow: 1,
    backgroundColor: "#f1f1f2",
  },
  iconView: {
    color: "white !important",
  },
  alignVertical: {
    display: "inline-grid",
  },
  hidden: {
    display: "none",
  },
});

class LockerStruct extends Component {
  constructor(props) {
    super(props);
    this.getSlots = this.getSlots.bind(this);
    this.getLocker = this.getLocker.bind(this);
    this.getLockerStructSize = this.getLockerStructSize.bind(this);
    this.groupBy = this.groupBy.bind(this);
    this.compare = this.compare.bind(this);
    this.statusIcon = this.statusIcon.bind(this);
    this.showActions = this.showActions.bind(this);
    this.getLastOrder = this.getLastOrder.bind(this);
    this.editSlot = this.editSlot.bind(this);
    this.openSlot = this.openSlot.bind(this);
    this.setDialog = this.setDialog.bind(this);
    this.setNotification = this.setNotification.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.loadPage = this.loadPage.bind(this);
    this.setOpenSlot = this.setOpenSlot.bind(this);
    this.setOpenSlotVariables = this.setOpenSlotVariables.bind(this);

    this.state = {
      slots: [],
      weight: 0,
      layout: [],
      columns: 0,
      circular: true,
      currSlot: null,
      openEdit: false,
      openView: false,
      openSlot: false,
      openningSlot: false,
      slot: null,
      callOnce: false,
      message: "",
      success: "danger",
      openSnackbar: false,
      currSlotOpen: null,
      AllocatedCount: 0,
      UnavailableCount: 0,
      AvailableCount: 0,
      NotAvailableCount: 0,
      locker: null,
      capacitySlots: 0,
      dirtySlots: 0,
      //TODO: definir o status de maintenance no slots
      maintenanceSlots: 0,
      allocatedClientCount: 0,
      user: {}
    };
  }

  componentDidMount() {
    this.getLocker(this.props.lockerId);
  }

  getLocker(lockerId) {

    const user = JSON.parse(localStorage.getItem('user'));

    console.log("USER", JSON.stringify(user.data));

    getLockerById(lockerId, (locker) => {
      this.setState({ locker: locker, user: user?.data });
      this.getSlots(this.props.lockerId);
    });
  }

  getNeodent() {
    let _user = localStorage.getItem('user')
    _user = JSON.parse(_user)

    if (!_user.agency || _user.agency.plataforma !== 'NEODENT') {
      return false;
    }

    return true;
  };

  getSlots(lockerId) {
    let { layout, columns, locker } = this.state;

    buscarEscaninho(lockerId, (slots) => {

      // console.log("SLOTS:", JSON.stringify(slots));

      let AllocatedCount = slots.filter((sl) => sl.status === "allocated")
        .length;
      let UnavailableCount = slots.filter(
        (sl) => sl.deviceCondition !== "control" && (sl.status === "unavailable" ||
          sl.status === "to_be_free")).length;

      // console.log({ UnavailableCount })

      let allocatedClientCount = slots.filter((sl) => sl.status === "allocatedClient").length;

      let NotAvailableCount = slots.filter(
        (sl) => sl.status === "reserved"
      ).length;

      let AvailableCount = slots.filter(
        (sl) => sl.status === "available"
      ).length;
      // console.log({ AvailableCount });


      let capacitySlots = slots.length - 1;
      let dirtySlots = slots.filter(
        (sl) => sl.status === "dirty"
      ).length;

      let maintenanceSlots = slots.filter(sl => sl.status === "to_be_free").length;

      let grouped = this.groupBy(slots, (slot) => slot.label);

      let maxKey = 0;

      for (var key of grouped.keys()) {
        
        let keyParse = parseLockerKey(key);
        
        if (maxKey < parseInt(keyParse.col)) {
          maxKey = parseInt(keyParse.col);
        }
      }

      columns = grouped.size;
      let weight = 3;
      let x = 0;

      for (let i = maxKey; i >= 0; i--) {
        // console.log(JSON.stringify(maxKey), i)

        if (grouped.get(`${i}L`)) {
          let sortedArray = grouped.get(`${i}L`).sort(this.compare);

          let y = 0;
          sortedArray.map((s, index) => {
            if (index > 0)
              y =
                this.getLockerStructSize(sortedArray[index - 1], weight).h + y;

            let size = this.getLockerStructSize(s, weight);
            layout.push({
              i: s.label,
              x: x,
              y,
              w: size.w,
              h: size.h,
              static: true,
              status: (s.deviceCondition === "control") ? this.statusIcon(s.deviceCondition) : this.statusIcon(s.status),
              color: (s.deviceCondition === "control") ? this.statusColor(s.deviceCondition) : this.statusColor(s.status),
              slot: s,
            });
          });

          x = x + weight;
        }

        // console.log("Maxkey:", maxKey);

        if ((i === 1) || ((maxKey === 0) && (i === 0))) { //if ((i === 1) || (i === 0)) {
          for (let dex = 0; dex <= maxKey; dex++) {
            let kk = dex === 0 ? `${dex}C` : `${dex}R`;
            if (!grouped.get(kk)) continue;
            let sortedArray = grouped.get(kk).sort(this.compare);

            let y = 0;
            sortedArray.map((s, index) => {
              if (index > 0) {
                y =
                  this.getLockerStructSize(sortedArray[index - 1], weight).h +
                  y;

                if (s.dimensions) {
                  switch (s.size) {
                    case "small":
                      y += 0.00;
                      break;
                    case "medium":
                      y += 0.00;
                      break;
                    case "large":
                      y += 0.00;
                      break;

                    default:
                      break;
                  }
                }
              }

              let size = this.getLockerStructSize(s, weight);

              layout.push({
                i: s.label,
                x: x,
                y,
                w: size.w,
                h: size.h,
                static: true,
                status: (s.deviceCondition === "control") ? this.statusIcon(s.deviceCondition) : this.statusIcon(s.status),
                color: (s.deviceCondition === "control") ? this.statusColor(s.deviceCondition) : this.statusColor(s.status),
                slot: s,
              });
            });
            x = x + weight;
          }
        }
      }


      this.setState({
        AvailableCount,
        UnavailableCount,
        AllocatedCount,
        NotAvailableCount,
        layout,
        circular: false,
        columns,
        weight,
        capacitySlots,
        dirtySlots,
        maintenanceSlots,
        allocatedClientCount
      });
    });
  }

  groupBy(list, keyGetter) {

    let map = new Map();

    list.forEach((item) => {
      let key = keyGetter(item);

      if (key) {
        let group = parseLocker(key);
        key = group.group; //key.substring(0, 2);

        let collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      }

    });

    return map;
  }

  compare(a, b) {
    const aLabel = parseLocker(a.label);
    const bLabel = parseLocker(b.label);

    // console.log(aLabel, bLabel);

    if (parseInt(aLabel.line) < parseInt(bLabel.line)) {
      return -1;
    }
    if (parseInt(aLabel.line) > parseInt(bLabel.line)) {
      return 1;
    }
    return 0;
  }

  getLockerStructSize(slot, weight) {
    let h = 0;

    switch (slot.size) {
      case "small":
        h = slot.dimensions ? (slot.dimensions.height * 1) / 130 : 1;
        return { w: weight, h };
      case "medium":
        h = slot.dimensions ? (slot.dimensions.height * 2) / 296 : 2;
        return { w: weight, h };
      case "large":
        h = slot.dimensions ? (slot.dimensions.height * 3) / 458 : 3;
        if (slot.label.includes("C7"))
          h = 2;
        return { w: weight, h };
      case "extra-large":
        return { w: weight, h: 4 };
      default:
        return { w: weight, h: 2 };
    }
  }

  statusIcon(status) {
    switch (status) {
      case "available":
        return Available;
      case "reserved":
        return Reserved;
      case "unavailable":
        return Block;
      case "dirty":
        return Warning;
      case "allocated":
      case "allocatedClient":
        return Allocated;
      case "control":
        return Control;
      default:
        return Block;
    }
  }

  statusColor(status) {
    switch (status) {
      case "available":
        return "#858585";
      case "reserved":
        return "#e4c309";
      case "unavailable":
        return "#f44336";
      case "dirty":
        return "#858585";
      case "allocated":
        return "#4caf50";
      case "allocatedClient":
        return "#26c6da";
      case "control":
        return "#D0D3D4"
      default:
        return "#f44336";
    }
  }

  showActions(data) {
    let { currSlot } = this.state;
    currSlot = data !== currSlot ? data : null;
    this.setState({ currSlot });
  }

  getLastOrder(slot) {
    this.setState({ openView: true, slot });
  }

  editSlot(slot) {
    this.setState({ openEdit: true, slot });
  }

  setOpenSlotVariables(slot) {
    this.setState({ openSlot: true, currSlotOpen: slot });
  }

  openSlot() {
    let slot = this.state.currSlotOpen;
    const user = this.state.user;

    const modelUser = {
      id: user?.id,
      name: user?.name
    };

    openSlot(this.props.lockerId, slot.id, slot.label, slot.slotName, modelUser, (status) => {
      this.setState(
        {
          message: `Comando enviado com sucesso`,
          success: "success",
          openSnackbar: true,
        },
        () => {
          setTimeout(() => {
            this.handleClose();
          }, 6000);
        }
      );
      //   if (status && status < 400) {
      //     this.setState(
      //       {
      //         message: `Porta ${slot.slotName} está aberta!`,
      //         success: "success",
      //         openSnackbar: true,
      //       },
      //       () => {
      //         setTimeout(() => {
      //           this.handleClose();
      //         }, 6000);
      //       }
      //     );
      //   } else {
      //     this.setState(
      //       {
      //         message: `Não foi possível abrir porta ${slot.slotName}!`,
      //         success: "danger",
      //         openSnackbar: true,
      //       },
      //       () => {
      //         setTimeout(() => {
      //           this.handleClose();
      //         }, 6000);
      //       }
      //     );
      //   }
    });
  }

  setDialog() {
    this.setState({ openEdit: false, openView: false });
  }

  setNotification(message, success) {
    this.setState({ message, success, openSnackbar: true });
    if (success === "success") {
      this.setState(
        { circular: true, weight: 0, layout: [], columns: 0, slots: [] },
        () => this.loadPage()
      );
    } else {
      setTimeout(() => {
        this.handleClose();
      }, 6000);
    }
  }

  loadPage() {
    this.componentDidMount();

    setTimeout(() => {
      this.handleClose();
    }, 6000);
  }

  handleClose() {
    this.setState({ openSnackbar: false });
  }

  setOpenSlot(openSlot) {
    console.log(openSlot);

    this.setState({ openSlot: false }, () => {
      if (openSlot) this.openSlot();
    });
  }

  render() {
    const { classes } = this.props;
    const {
      AvailableCount,
      UnavailableCount,
      AllocatedCount,
      NotAvailableCount,
      layout,
      circular,
      columns,
      weight,
      currSlot,
      capacitySlots,
      dirtySlots,
      maintenanceSlots,
      allocatedClientCount
    } = this.state;

    return circular ? (
      <div className={classes.root}>
        <CircularProgress />
      </div>
    ) : (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={2}>
            <Card className="locker-background">
              <CardHeader className="locker-align-text" color="available" stats icon>
                <CardIcon className="locker-slots" color="available">
                  <Tooltip title="Compartimentos disponíveis para depósito de encomenda">
                    <VerticalSplit />
                  </Tooltip>
                </CardIcon>
                <h3 className={classes.cardTitle}>
                  {AvailableCount}
                </h3>
              </CardHeader>

              <h5 className={classes.cardTitle}><p className="locker-padding">Disponíveis</p></h5>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <Card className="locker-background">
              <CardHeader className="locker-align-text" color="warning" stats icon>
                <CardIcon className="locker-yellow locker-slots" color="warning">
                  <Tooltip title="Compartimentos reservados que serão alocados pelo agente de Correios">
                    <VerticalSplit />
                  </Tooltip>
                </CardIcon>
                <h3 className={classes.cardTitle}>
                  {NotAvailableCount}
                </h3>
              </CardHeader>
              <h5 className={classes.cardTitle}><p className="locker-padding">Reservadas</p></h5>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <Card className="locker-background">
              <CardHeader className="locker-align-text" color="success" stats icon>
                <CardIcon className="locker-slots" color="success">
                  <Tooltip title="Compartimentos com encomenda depositada pelo agente de Correios">
                    <VerticalSplit />
                  </Tooltip>
                </CardIcon>
                <h3 className={classes.cardTitle}>
                  {AllocatedCount}
                </h3>
              </CardHeader>
              <h5 className={classes.cardTitle}><p className="locker-padding">Alocado pelo agente</p></h5>
            </Card>
          </GridItem>
          { <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="warning" stats icon>
                  <CardIcon className="locker-slots" color="info">
                    <Tooltip title="Compartimentos com encomenda depositada pelo cliente">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {allocatedClientCount}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Alocado pelo cliente</p></h5>
              </Card>
            </GridItem>}

          <GridItem xs={12} sm={6} md={2}>
            <Card className="locker-background">
              <CardHeader className="locker-align-text" color="danger" stats icon>
                <CardIcon className="locker-slots" color="danger">
                  <Tooltip title="Compartimentos bloqueados para alocação">
                    <VerticalSplit />
                  </Tooltip>
                </CardIcon>
                <h3 className={classes.cardTitle}>
                  {UnavailableCount}
                </h3>
              </CardHeader>
              <h5 className={classes.cardTitle}><p className="locker-padding">Bloqueadas</p></h5>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={2}>
            <Card className="locker-background">
              <CardHeader className="locker-align-text" color="danger" stats icon>
                <CardIcon className="locker-black" color="danger">
                  <Tooltip title="Quantidade total de compartimentos">
                    <VerticalSplit />
                  </Tooltip>
                </CardIcon>
                <h3 className={classes.cardTitle}>
                  {capacitySlots}
                </h3>
              </CardHeader>
              <h5 className={classes.cardTitle}><p className="locker-padding">Total</p></h5>
            </Card>
          </GridItem>

        </GridContainer>
        <GridLayout
          cols={columns * weight}
          rowHeight={weight * 15}
          width={columns * weight * 50}
        >
          {layout.map((item) => (
            <div
              onClick={(data) => this.showActions(item.i)}
              key={item.i}
              data-grid={item}
            >
              <div
                className="divContainer"
                style={{ backgroundColor: `${item.color}` }}
              >
                {item.i === currSlot ? (
                  <>
                    <span className={item.h > 1 ? "text" : classes.hidden}>
                      {item.i}
                    </span>
                    <div className={item.h > 2 ? classes.alignVertical : null}>
                      <IconButton
                        aria-label="view"
                        onClick={() => this.getLastOrder(item.slot)}
                      >
                        <Tooltip key={item.i} title="Visualizar as três últimas encomendas depositadas">
                          <Visibility fontSize="small" className={classes.iconView} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        aria-label="view"
                        onClick={() => this.editSlot(item.slot)}
                      >
                        <Tooltip key={item.i} title="Editar compartimento">
                          <Edit fontSize="small" className={classes.iconView} />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        aria-label="view"
                        onClick={() => this.setOpenSlotVariables(item.slot)}
                      >
                        <Tooltip key={item.i} title="Abrir compartimento">
                            <LockOpen fontSize="small" className={classes.iconView} />
                        </Tooltip>
                        {/* {this.getNeodent() ?
                          <Tooltip key={item.i} title="Abrir compartimento">
                            <LockOpen className={classes.iconView} />
                          </Tooltip>
                        : ''} */}
                      </IconButton>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="text">{item.i}</span>
                    <Tooltip key={item.i} title="Clique no compartimento desejado para editá-lo ou visualizar as três últimas encomendas depositadas">
                      <img alt={item.i} src={item.status} />
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          ))}
        </GridLayout>
        {
          this.state.openEdit ? (
            <EditSlot
              lockerId={this.props.lockerId}
              slot={this.state.slot}
              open={this.state.openEdit}
              setNotification={this.setNotification}
              onChange={this.setDialog}
            />
          ) : null
        }
        {
          this.state.openView ? (
            <ViewSlot
              lockerId={this.props.lockerId}
              slot={this.state.slot}
              open={this.state.openView}
              setNotification={this.setNotification}
              onChange={this.setDialog}
            />
          ) : null
        }
        {
          this.state.openSlot ? (
            <OpenSlot open={this.state.openSlot} onChange={this.setOpenSlot} />
          ) : null
        }
        <Snackbar
          place="tc"
          color={this.state.success}
          icon={AddAlert}
          message={this.state.message}
          open={this.state.openSnackbar}
          closeNotification={this.handleClose}
          close
        />
      </div >
    );
  }
}

export default withStyles(useStyles)(LockerStruct);
